/* ============================================================================
   URIC ACID PURGE — comportamiento compartido de las secciones.
   Se carga desde cada sección; el guard de abajo evita que corra dos veces.
   ============================================================================ */
(function () {
  if (window.__lpInit) return;
  window.__lpInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var formularios = [];   // todas las secciones de oferta de la página
  var espejando = false;  // evita el ping-pong al sincronizarlas entre sí

  /* --- reveal on scroll ---------------------------------------------------
     La landing original marcaba <body class="anim"> y observaba los .rv.
     Acá el contenedor de cada sección hace de body. */
  function initReveal(root) {
    var page = root.querySelector('.lp-page');
    if (!page) return;
    if (reduce) return;
    page.classList.add('anim');
    var items = page.querySelectorAll('.rv');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('on'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('on'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* --- selector de packs --------------------------------------------------
     Marca visualmente el .pack elegido y sincroniza el precio de la barra
     sticky con la variante seleccionada. */
  /* Una landing puede tener DOS secciones de oferta (arriba en el above the
     fold y otra vez al cierre). Hay que enganchar todas, no la primera: con
     querySelector la segunda quedaba muerta y el pack elegido nunca llegaba
     al input oculto. */
  function initPacks(root) {
    var forms = root.querySelectorAll('[data-lp-packs]');
    for (var i = 0; i < forms.length; i++) initUnFormulario(forms[i]);
  }

  function initUnFormulario(form) {
    if (form.__lpPacks) return;
    form.__lpPacks = true;
    var packs = form.querySelectorAll('.pack');
    var oculto = form.querySelector('[data-lp-variante]');

    function sync() {
      var elegido = null;
      packs.forEach(function (p) {
        var radio = p.querySelector('input[type="radio"]');
        var on = radio && radio.checked;
        p.classList.toggle('sel', !!on);
        if (on) elegido = p;
      });
      if (!elegido) return;

      /* La variante viaja en el input oculto name="id" — es lo que leen
         Releasit y cualquier otra app de checkout. Los radios son solo la UI:
         si una app leyera [name="id"] sobre un grupo de radios se quedaría con
         el primero y mandaría siempre el primer pack. */
      var radio = elegido.querySelector('input[type="radio"]');
      if (oculto && radio && oculto.value !== radio.value) {
        oculto.value = radio.value;
        /* Avisar a las apps que escuchan el formulario de producto. */
        oculto.dispatchEvent(new Event('change', { bubbles: true }));
        oculto.dispatchEvent(new Event('input', { bubbles: true }));
      }

      /* En modo cantidad los tres packs son la MISMA variante: lo que cambia
         es cuántas unidades van al carrito. */
      var cant = elegido.getAttribute('data-cantidad');
      var inputCant = form.querySelector('input[name="quantity"]');
      if (cant && inputCant && inputCant.value !== cant) {
        inputCant.value = cant;
        inputCant.dispatchEvent(new Event('change', { bubbles: true }));
        inputCant.dispatchEvent(new Event('input', { bubbles: true }));
      }

      var precio = elegido.getAttribute('data-precio') || '';
      document.querySelectorAll('[data-lp-sticky-precio]').forEach(function (el) {
        el.textContent = precio;
      });

      /* Las dos ofertas tienen que quedar en el mismo pack. Si no, el cliente
         elige 3 frascos arriba, baja, y el botón del cierre manda 2. */
      /* Se espeja por CLAVE, no por valor: en modo cantidad los tres packs
         comparten el mismo id de variante y buscar por valor marcaba los tres. */
      if (!espejando && radio) {
        espejando = true;
        var clave = radio.getAttribute('data-clave') || radio.value;
        formularios.forEach(function (otro) {
          if (otro.form !== form) otro.elegir(clave);
        });
        espejando = false;
      }
    }

    formularios.push({
      form: form,
      elegir: function (clave) {
        var alguno = false;
        packs.forEach(function (p) {
          var r = p.querySelector('input[type="radio"]');
          var k = r ? (r.getAttribute('data-clave') || r.value) : null;
          if (k === clave) { r.checked = true; alguno = true; }
        });
        if (alguno) sync();
      }
    });

    packs.forEach(function (p) {
      var radio = p.querySelector('input[type="radio"]');
      if (radio) radio.addEventListener('change', sync);
    });
    sync();

    /* Solo cuando se vende por el checkout de Shopify en vez de Releasit:
       /cart/{variante}:1 REEMPLAZA el carrito y cae directo en el checkout,
       para que nada que el cliente tuviera guardado se cuele en el pedido. */
    if (form.hasAttribute('data-lp-directo')) {
      form.addEventListener('submit', function (ev) {
        if (!oculto || !oculto.value) return;
        ev.preventDefault();
        window.location.href = '/cart/' + oculto.value + ':1';
      });
    }
  }
  /* --- galería ------------------------------------------------------------
     El swipe lo hace el navegador (scroll-snap). Acá solo conectamos las
     miniaturas y marcamos cuál está a la vista. */
  function initGaleria(root) {
    root.querySelectorAll('[data-lp-galeria]').forEach(function (gal) {
      if (gal.__lpGal) return;
      gal.__lpGal = true;
      var vista = gal.querySelector('.gal-vista');
      var minis = gal.querySelectorAll('.gal-mini');
      if (!vista || !minis.length) return;

      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var i = parseInt(mini.getAttribute('data-gal-i'), 10) || 0;
          vista.scrollTo({ left: vista.clientWidth * i, behavior: reduce ? 'auto' : 'smooth' });
        });
      });

      var pendiente = false;
      vista.addEventListener('scroll', function () {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(function () {
          pendiente = false;
          var i = Math.round(vista.scrollLeft / vista.clientWidth);
          minis.forEach(function (m, j) { m.classList.toggle('on', j === i); });
        });
      });
    });
  }

  /* --- contador de la barra de oferta --------------------------------------
     Con data-hasta cuenta hacia una fecha real. Sin ella cuenta los minutos de
     la visita, pero guarda el arranque en sessionStorage: así no se reinicia
     cada vez que el cliente recarga o vuelve atrás, que es lo que delata a los
     contadores falsos. Al llegar a cero se queda en cero, no rebota. */
  function initContador(root) {
    root.querySelectorAll('[data-lp-contador]').forEach(function (el) {
      if (el.__lpTic) return;
      el.__lpTic = true;
      var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      var hasta = el.getAttribute('data-hasta');
      var fin;

      if (hasta) {
        fin = new Date(hasta).getTime();
        if (isNaN(fin)) return;
      } else {
        var mins = parseInt(el.getAttribute('data-min'), 10) || 30;
        var clave = 'lpContador';
        var guardado = null;
        try { guardado = sessionStorage.getItem(clave); } catch (e) {}
        fin = guardado ? parseInt(guardado, 10) : Date.now() + mins * 60000;
        if (!guardado) { try { sessionStorage.setItem(clave, String(fin)); } catch (e) {} }
      }

      function dos(n) { return n < 10 ? '0' + n : String(n); }

      function tic() {
        var falta = Math.max(0, fin - Date.now());
        var t = Math.floor(falta / 1000);
        if (h) h.textContent = dos(Math.floor(t / 3600));
        if (m) m.textContent = dos(Math.floor(t / 60) % 60);
        if (s) s.textContent = dos(t % 60);
        if (falta > 0) setTimeout(tic, 1000);
      }
      tic();
    });
  }

  /* --- carrusel de reseñas ------------------------------------------------- */
  function initCarrusel(root) {
    root.querySelectorAll('[data-lp-carrusel]').forEach(function (car) {
      if (car.__lpCar) return;
      car.__lpCar = true;
      var cont = car.parentElement.querySelector('[data-lp-puntos]');
      if (!cont) return;
      var puntos = cont.querySelectorAll('.punto');
      var tarjetas = car.querySelectorAll('.testi');

      puntos.forEach(function (p) {
        p.addEventListener('click', function () {
          var i = parseInt(p.getAttribute('data-i'), 10) || 0;
          var t = tarjetas[i];
          if (t) car.scrollTo({ left: t.offsetLeft - car.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
        });
      });

      var pend = false;
      car.addEventListener('scroll', function () {
        if (pend) return;
        pend = true;
        requestAnimationFrame(function () {
          pend = false;
          var centro = car.scrollLeft + car.clientWidth / 2, cerca = 0, dif = Infinity;
          tarjetas.forEach(function (t, j) {
            var c = t.offsetLeft - car.offsetLeft + t.clientWidth / 2;
            if (Math.abs(c - centro) < dif) { dif = Math.abs(c - centro); cerca = j; }
          });
          puntos.forEach(function (p, j) { p.classList.toggle('on', j === cerca); });
        });
      });
    });
  }

  function boot() {
    initContador(document);
    initCarrusel(document);
    initReveal(document);
    initPacks(document);
    initGaleria(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* El editor de temas re-renderiza secciones sin recargar la página. */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target;
    var page = root.querySelector('.lp-page');
    if (page && !reduce) {
      page.classList.add('anim');
      page.querySelectorAll('.rv').forEach(function (el) { el.classList.add('on'); });
    }
    initPacks(root);
    initGaleria(root);
    initCarrusel(root);
  });
})();
